// extracted by mini-css-extract-plugin
module.exports = {"dicas":"tipsStyles_dicas__M_dY5","tipsDlg":"tipsStyles_tipsDlg__G5ci2"};